import React from "react";
import PropTypes from "prop-types";
import { PageLayout, WarningBox } from "../../components";
import {
  getChosenAnswer,
  sortAnswers
} from "../helpers";
import { YourCarConditionHelmet } from "../../components/SellHelmets";
import { renderCorrectLabel } from "./helpers";
import { MultipleChoiceQuestionIds } from "../../data/QuestionData";
import { AssumptionsRadioAndCheckboxQuestion } from "../../components/AssumptionQuestions/AssumptionsRadioAndCheckboxQuestion";

export default function ConditionAnswersReview({
  questionsAndAnswers,
  conditionQuestions,
  handleChange,
  answersChanged,
  handleClick,
  selectedQuestionsHaveChanged,
  checkboxState,
  handleCheckboxChange
}) {
  const questionsOptions = conditionQuestions.map((question) => {
    const sortedAnswers = sortAnswers(question.answers);
    const options = sortedAnswers.map((answer) => (
      <option
        key={answer.id}
        className="ch-text--ellipsis ch-fs--1"
        value={answer.id}
      >
        {renderCorrectLabel(question, answer)}
      </option>
    ));

    if (MultipleChoiceQuestionIds?.includes(question.id)) {
      return (
        <div key={question.id}>
          <AssumptionsRadioAndCheckboxQuestion
            question={question}
            handleAssumptionRadioChange={handleChange}
            selectedQuestionsHaveChanged={selectedQuestionsHaveChanged}
            handleCheckboxChange={handleCheckboxChange}
            checkboxState={checkboxState}
          />
        </div>
      );
    } else {
      return (
        <div key={question.id} className="ch-pb--4">
          <label
            className="ch-form__control-label ch-fs--3"
            htmlFor={question.id}
          >
            {question.content}
          </label>
          <select
            data-testid={question.id}
            id={question.id}
            className="ch-form__control ch-text--ellipsis ch-text--clip"
            defaultValue={getChosenAnswer(question, questionsAndAnswers)}
            onChange={({ target: { value } }) => {
              handleChange(question.id, parseInt(value));
            }}
          >
            {options}
          </select>
        </div>
      );
    }
  });

  return (
    <>
      <YourCarConditionHelmet />
      <PageLayout>
        <PageLayout.Header step={11} title="Your car's condition" />
        <PageLayout.Content>
          <h1 className="ch-fs--4 ch-mb--1">Your answers</h1>
          <p className="ch-fs--3 ch-mb--4">
            Making updates to your answers will change your valuation.
          </p>
          {questionsOptions}
          {answersChanged && <WarningBox />}
        </PageLayout.Content>
        <PageLayout.Footer>
          <button
            onClick={handleClick}
            className="ch-btn ch-btn--success ch-display--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
            type="button"
          >
            {answersChanged ? "Change and update offer" : "OK"}
          </button>
        </PageLayout.Footer>
      </PageLayout>
    </>
  );
}

ConditionAnswersReview.propTypes = {
  onSubmit: PropTypes.func
};
